exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-settings{\n  position: absolute;\n  top: 20px;\n  right: 6px;\n  padding: 10px;\n}\n\n.admin-popup{\n  background-color: white;\n  position: fixed;\n  z-index: 50;\n  width: 720px;\n  min-height: 480px;\n  top: 50%; right: 50%;\n  -webkit-transform: translate(50%,-50%);\n  -ms-transform: translate(50%,-50%);\n  transform: translate(50%,-50%);\n  box-shadow: 0 3px 3px 3px rgba(0,0,0,0.2);\n  border-radius: 6px !important;\n}\n\n@media only screen\n  and (max-device-width: 1024px) {\n    .admin-popup{\n      width:520px;\n    }\n}\n\n.logout{\n  color: #ff4040;\n}\n", ""]);

// exports
